// extracted by mini-css-extract-plugin
export default {"container":"TDrELxJAXSJdalT8bzeg","inBox":"eHwY1PWV9cxjPMg1AjwJ","outBox":"dOkaYG74b2Avr7buVqiw"};